export interface NavItem {
  label: string;
  path: string;
}

export interface StatItem {
  value: string;
  label: string;
  desc: string;
}

export interface Testimonial {
  name: string;
  role: string;
  content: string;
}

export interface Principle {
  icon: string;
  title: string;
  desc: string;
}

export const siteInfo = {
  name: "黑料百科",
  slogan: "人物词条 · 话题档案 · 时间线一网打尽",
  intro:
    "黑料百科把公开报道里零散的话题，整理成以人物为单位的结构化词条，用时间线还原每一步的来龙去脉，让吃瓜不再只靠碎片截图。",
  email: "editor@heiliaobaike.com",
  businessEmail: "hello@heiliaobaike.com",
  replyTime: "工作日 24 小时内回复",
  disclaimer:
    "站内人物均为虚构角色设定，内容为原创娱乐向创作；如与现实人物重名，纯属巧合。词条只整理公开信息，不收录任何非公开个人内容。",
};

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "词条分类", path: "/category/star" },
  { label: "热度榜单", path: "/ranking" },
  { label: "常见问题", path: "/faq" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

export const stats: StatItem[] = [
  { value: "1,860+", label: "收录词条", desc: "覆盖明星、创作者与影视话题" },
  { value: "12,400+", label: "事件节点", desc: "按日期整理的时间线记录" },
  { value: "92%", label: "读者复访率", desc: "每周回访查看更新情况" },
  { value: "每日", label: "更新频率", desc: "热榜话题持续跟进" },
];

export const testimonials: Testimonial[] = [
  {
    name: "小满",
    role: "娱乐资讯爱好者",
    content:
      "以前看八卦要翻十几个帖子才能拼出前后顺序，现在打开一个词条，时间线从第一条到最新都排好了，省事太多。",
  },
  {
    name: "阿哲",
    role: "内容编辑",
    content:
      "做选题的时候会先来这里看背景资料，基本信息表那一栏特别实用，不用自己再去重新核对一遍时间。",
  },
  {
    name: "柚子",
    role: "在校学生",
    content:
      "分类做得很清楚，我只关心影视那一块，直接从分类进去看就行，不会被别的内容刷屏。",
  },
  {
    name: "老陈",
    role: "行业观察者",
    content:
      "难得的是它会标明信息可信度，遇到匿名说法会直接提示，这点比很多同类站点靠谱。",
  },
];

export const principles: Principle[] = [
  {
    icon: "ri-links-line",
    title: "只整理公开信息",
    desc: "词条内容全部来自官方说明、官方物料与可追溯的公开报道，不使用无法核实的匿名说法下结论。",
  },
  {
    icon: "ri-file-list-3-line",
    title: "时间线优先",
    desc: "任何话题都先理清顺序，再谈观点。按日期排列的节点让读者自己判断，而不是被结论牵着走。",
  },
  {
    icon: "ri-shield-check-line",
    title: "不越界隐私",
    desc: "不收录证件、私人联系方式、住址等非公开内容，涉及未成年人的信息一律不整理。",
  },
  {
    icon: "ri-refresh-line",
    title: "有误就改",
    desc: "收到纠错后核实并修改，同时在词条更新时间中记录改动，让内容变化可以被追溯。",
  },
];

export const aboutSections = [
  {
    title: "我们是谁",
    desc: "黑料百科是一个以人物为单位整理娱乐话题的内容站点。我们不做情绪化的标题，而是把一件事发生过的节点按顺序排清楚，让你三分钟内掌握脉络。",
  },
  {
    title: "为什么做这件事",
    desc: "同一个话题在不同平台往往被切成无数碎片，前后语境丢失后容易被误读。我们想提供一个稳定、完整、可以反复回看的参照页。",
  },
  {
    title: "我们的读者",
    desc: "关心娱乐资讯的普通读者、需要背景资料的内容创作者、以及希望快速了解一件事全貌的围观者。",
  },
];